// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://db.opauction.net";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Inp4Z3pwZGNyb2FxcXV1bHZ6c3FtIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjkxNjU1NTEsImV4cCI6MjA4NDc0MTU1MX0.acfwAgH3LyDB1ORAnxESwjuLaZBoxUhvw2N2xMTSwxk";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});
